import React, { useState } from 'react';
import { HomeModuleHub } from './HomeModuleHub';
import { AccountingDashboard } from './AccountingDashboard';

interface MasterDashboardProps {
  setActiveItem?: (id: string) => void;
  onOpenSettings?: (section: string) => void;
}

export function MasterDashboard({ setActiveItem, onOpenSettings }: MasterDashboardProps) {
  const [view, setView] = useState<'hub' | 'accounting'>('hub');

  if (view === 'accounting') {
    return (
      <AccountingDashboard
        setActiveItem={setActiveItem}
        onBack={() => setView('hub')}
      />
    );
  }

  return (
    <HomeModuleHub
      setActiveItem={(id) => setActiveItem?.(id)}
      onOpenSettings={onOpenSettings}
      onOpenAccounting={() => setView('accounting')}
    />
  );
}

export default MasterDashboard;
